import { styled } from 'goober';
import { forwardRef } from 'react';

export const Shadow = styled('div', forwardRef)<{
    $position: 'left' | 'right' | 'top' | 'bottom';
}>`
    position: absolute;
    ${({ $position }) =>
        $position === 'left' || $position === 'right'
            ? `${$position}: 0px; top: 0px; bottom: 0px; width: 40px;`
            : `${$position}: 0px; left: 0px; right: 0px; height: 40px;`}

    pointer-events: none;
    background: ${({ $position }) =>
        $position === 'left' || $position === 'right'
            ? `linear-gradient(to ${
                  $position === 'left' ? 'right' : 'left'
              }, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0) 100%), transparent`
            : `linear-gradient(to ${
                  $position === 'top' ? 'bottom' : 'top'
              }, rgba(255, 255, 255, 0.95), rgba(255, 255, 255, 0) 100%), transparent`};
`;
